<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { video_pressets } from "../utils/video_pressets";
import { tile_info } from "../states/auth";
import { getRandomBg } from "../utils/randomBg";
import { cameraTrack } from "../states/media/state";

const videoEl = ref<HTMLVideoElement | null>(null);
onMounted(async () => {
  watch(
    () => ({
      track: cameraTrack.value,
      el: videoEl.value,
    }),
    (next) => {
      if (next.track && next.el) {
        next.track.attach(next.el);
      }
    },
    { immediate: true },
  );
});
</script>
<template>
  <div class="preview-video">
    <video
      v-if="cameraTrack"
      class="video-el mirror"
      ref="videoEl"
      :width="220"
      :height="124"
      autoplay
      :controls="false"
    />
    <div
      v-else
      class="image-preview"
      :style="{
        width: `${video_pressets.preview.width}px`,
        height: `${video_pressets.preview.height}px`,
      }"
    >
      <div
        class="preview-avatar-size preview-avatar"
        :style="{
          backgroundColor:
            tile_info.name && !tile_info.avatar
              ? getRandomBg(tile_info.name)
              : '#d9d9d9',
        }"
      >
        <img
          v-if="tile_info.avatar"
          class="covered"
          :src="tile_info.avatar"
          alt=""
        />
        <span v-else-if="tile_info.name" class="covered name-char">{{
          tile_info.name
        }}</span>
        <img v-else src="@images/default_avatar.svg" class="covered" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.preview-video {
  height: 124px;
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mirror {
  transform: scaleX(-1);
}

.video-el {
  border-radius: 8px;
  background: #d9d9d9;
}

.image-preview {
  max-width: 100%;
  display: flex;
  border-radius: 8px;
  background-color: #d9d9d9;
  align-items: center;
  justify-content: center;
}

.preview-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.name-char {
  font-size: 30px;
  color: #1e1818;
  text-align: center;
}
</style>
